export default class ProjectPolicy {

    /**
     * Check if user can view a specific project
     * @param {Object} user
     * @param {Number} id
     * @return {Boolean}
     */
    view(user, id) {
        return user.role.name === 'admin' || 
               user.role.name === 'client_admin' ||
               (user.permissions?.project?.[id]?.read ?? false);
    }

    /**
     * Check if user can create a project
     * @param {Object} user
     * @return {Boolean}
     */
    create(user) {
        return user.role.name === 'admin' || 
               user.role.name === 'client_admin' ||
               (user.permissions?.project?.global?.create ?? false);
    }

    /**
     * Check if user can update a project
     * @param {Object} user
     * @param {Object} project
     * @return {Boolean}
     */
    update(user, id) {
        return user.role.name === 'admin' || 
               user.role.name === 'client_admin' ||
               (user.permissions?.project?.[id ?? '']?.update ?? false);
    }

    /**
     * Check if user can delete a project
     * @param {Object} user
     * @param {Number} id
     * @return {Boolean}
     */
    delete(user, id) {
        // Only allow deletion if the user is admin or has explicit delete permission
        return user.role.name === 'admin' || 
               user.role.name === 'client_admin' ||
               (user.permissions?.project?.[id ?? '']?.delete ?? false);
    }

    /**
     * Check if user can restore a soft-deleted project
     * @param {Object} user
     * @param {Number} id
     * @return {Boolean}
     */
    restore(user, id) {
        return user.role.name === 'admin' || 
               user.role.name === 'client_admin';
    }

    /**
     * Check if user can force delete a project
     * @param {Object} user
     * @param {Number} id
     * @return {Boolean}
     */
    forceDelete(user, id) {
        // Only allow force delete for admins
        return user.role.name === 'admin';
    }
}
